import { useUser } from '@/hooks/auth/use-user';
import useTaskOperations from '@/hooks/tasks/use-task-operations';
import { DateRangeOption } from '@/hooks/tasks/use-task-operations';

/**
 * Hook to manage task data fetching and operations
 */
export const useTaskData = (
  dateRange: DateRangeOption, 
  currentDate: Date, 
  strictDateRange: boolean = false,
  noDateFilter: boolean = false
) => {
  const { user } = useUser();
  
  const taskOperations = useTaskOperations(dateRange, currentDate, strictDateRange, noDateFilter);
  
  const {
    activeTasks,
    completedTasks,
    isLoading = false,
    addTask: dbAddTask,
    completeTask: dbCompleteTask,
    uncompleteTask: dbUncompleteTask,
    removeTask: dbRemoveTask,
    updateTask: dbUpdateTask,
    refetch,
  } = taskOperations;

  // Arrays are now stable from useTaskOperations, no need for additional memoization
  return {
    user,
    dbActiveTasks: activeTasks,
    dbCompletedTasks: completedTasks,
    isLoading,
    dbAddTask,
    dbCompleteTask,
    dbUncompleteTask,
    dbRemoveTask,
    dbUpdateTask,
    refetch
  };
};
